import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

const state={
	adminUserInfo:{
		
	},
	generalInfo:{adminId:""},
	platformInfo:{
		platformName:"融e购平台"
	},
	RYL:{
		setId:window.g.YQSetId,
	}
}



const mutations={
	keepAdminUserInfo(state,adminUserInfo){
		state.adminUserInfo=adminUserInfo;
	},
	setGeneralInfo(state,info){
		state.generalInfo=info;
	}
}

const action={
	
}





export default new Vuex.Store({
	state,
	mutations,
	action
});


// WEBPACK FOOTER //
// ./src/store/index.js